const geomConfig = {
  layers: [
    {
      layer: 10,
      desc: "Controllers",
      y: -1,
      t2: 0.001,
      t3: 0.298,
      y2: -0.1,
      y3: 0.667,
      color: "#caced2", // Example color
      metalness: 0.8,
      roughness: 0.2,
    },
    {
      layer: 20,
      desc: "Plates",
      y: -1,
      t2: 0.001,
      t3: 0.667,
      y2: 0,
      y3: 0, // Plates at height 0 in 3D so xmwblocks sit on top
      color: "#d1c184", // Example color
      metalness: 0.9,
      roughness: 0.15,
    },
    {
      layer: 30,
      desc: "X-mwblocks",
      y: 1,
      t2: 0.001,
      t3: 0.365,
      y2: 0.1,
      y3: 0,
      color: "#2ecc71", // Example color
      metalness: 0.9,
      roughness: 0.15,
    },
    {
      layer: 37,
      desc: "Housings",
      y: -1,
      t2: 0.001,
      t3: 2.636,
      y2: 0,
      y3: 1.556,
      color: "#b3b3b3", // Example color
      metalness: 0.9,
      roughness: 0.4,
    },
    {
      layer: 33,
      desc: "Walls",
      y: 1,
      t2: 0.001,
      t3: 2.887,
      y2: 0.1,
      y3: 0,
      color: "#d1c184", // Example color
      metalness: 0.9,
      roughness: 0.15,
    },
    {
      layer: 34,
      desc: "Shield",
      y: 1,
      t2: 0.001,
      t3: 2.636,
      y2: 0.2,
      y3: 0.365,
      color: "#caced2", // Example color
      metalness: 0.9,
      roughness: 0.15,
    },
    {
      layer: 35,
      desc: "Probes",
      y: 1,
      t2: 0.001,
      t3: 2.636,
      y2: 0.11,
      y3: 0,
      color: "#d1c184", // Example color
      metalness: 0.9,
      roughness: 0.15,
    },
    {
      layer: 36,
      desc: "EndLaunchConnectors",
      y: 1,
      t2: 0.001,
      t3: 2.636,
      y2: 0.1,
      y3: 0.249,
      color: "#caced2", // Example color
      metalness: 0.85,
      roughness: 0.2,
    },
    {
      layer: 40,
      desc: "Jumper",
      y: 1,
      t2: 0.001,
      t3: 0.03,
      y2: 0.25,
      y3: 0.365,
      color: "#caced2", // Example color
      metalness: 0.9,
      roughness: 0.15,
    },
    {
      layer: 50,
      desc: "Anchors",
      y: 1,
      t2: 0.001,
      t3: 0.793,
      // y2: below lids (70: 0.3), above jumpers (40: 0.25) and xmwblocks (30: 0.1) in 2D
      y2: 0.28,
      y3: 0.365,
      color: "#caced2", // Example color
      metalness: 0.5,
      roughness: 0.25,
    },
    {
      layer: 60,
      desc: "HousingConnectors",
      y: 1,
      t2: 0.001,
      t3: 3.941,
      y2: 0.15,
      y3: 0.375,
      color: "#888888", // Example color
      metalness: 0.9,
      roughness: 0.4,
    },
    {
      layer: 70,
      desc: "Lids",
      y: 1,
      t2: 0.001,
      t3: 1.75,
      y2: 0.3,
      y3: 1.8081, //829,
      color: "#d1c184", // Example color
      metalness: 0.9,
      roughness: 0.15,
    },
    {
      layer: 80,
      desc: "Screws",
      y: 1,
      t2: 0.001,
      t3: 0.2,
      y2: 0.3,
      y3: 0.01,
      color: "#caced2", // Example color
      metalness: 0.9,
      roughness: 0.15,
    },
    {
      layer: 90,
      desc: "Ruller_Quarter",
      y: 1,
      t2: 0.001,
      t3: 0.2,
      y2: 0.15,
      y3: 0.01,
      color: "#caced2", // Example color
      metalness: 0.5,
      roughness: 0.5,
    },
  ],
};

export { geomConfig };
